(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sonex-energy-mini"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('[data-sonex-energy-mini]').forEach(function(root){if(root.dataset.initialized==='1')return;root.dataset.initialized='1';function get(selector,min,max){var input=root.querySelector(selector),value=Number(input&&input.value);return Number.isFinite(value)&&value>=min&&value<=max?value:null}function money(v){return'Rs '+Math.round(v).toLocaleString()}function units(v){return v.toLocaleString(undefined,{minimumFractionDigits:v<10?2:1,maximumFractionDigits:2})+' units'}function calculate(){var watts=get('[data-energy-watts]',1,1000),count=get('[data-energy-count]',1,50),hours=get('[data-energy-hours]',.1,24),days=get('[data-energy-days]',1,31),rate=get('[data-energy-rate]',.01,1000),error=root.querySelector('[data-energy-error]');if(watts===null||count===null||hours===null||days===null||rate===null){error.hidden=false;root.querySelector('[data-energy-monthly-units]').textContent='—';root.querySelector('[data-energy-monthly-cost]').textContent='—';root.querySelector('[data-energy-annual-cost]').textContent='—';return}error.hidden=true;var monthlyUnits=watts*count*hours*days/1000,monthlyCost=monthlyUnits*rate;root.querySelector('[data-energy-monthly-units]').textContent=units(monthlyUnits);root.querySelector('[data-energy-monthly-cost]').textContent=money(monthlyCost);root.querySelector('[data-energy-annual-cost]').textContent=money(monthlyCost*12)}root.querySelector('[data-energy-calculate]').addEventListener('click',calculate)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonex-room-preview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sonex-room-preview')) {
  customElements.define('sonex-room-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.q = selector => this.querySelector(selector);
      this.qa = selector => [...this.querySelectorAll(selector)];
      this.copy = JSON.parse(this.q('[data-copy]').textContent);
      this.language = 'en';
      this.items = this.qa('[data-item]').map(el => ({...el.dataset,options:JSON.parse(el.dataset.options),optionNames:JSON.parse(el.dataset.optionNames)}));
      this.category = 'all';
      this.slots = {a:{item:null,fan:null,token:0},b:{item:null,fan:null,token:0}};
      this.activeSlot = 'a'; this.comparing = false; this.room = null;
      this.position = {x:.5,y:.22,scale:.32,angle:0};
      this.roomToken = 0; this.stateVersion = 0; this.roomOnly = false; this.fanSelected = null;
      this.cache = new Map(); this.modelCards = new Map();
      for (const model of new Set(this.items.map(item => item.model))) {
        const matching = this.items.filter(item => item.model === model);
        const item = matching.find(item => item.available === 'true') || matching[0];
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'srp-model-card'; button.dataset.model = model; button.dataset.category = item.category;
        const image = document.createElement('img'); image.width = 320; image.height = 200; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async';
        const name = document.createElement('strong'); name.textContent = model; name.dir = 'auto';
        const price = document.createElement('span'); price.className = 'srp-model-price'; price.dir = 'ltr';
        const selected = document.createElement('span'); selected.className = 'srp-model-selected';
        button.append(image,name,price,selected);
        button.addEventListener('click',() => {
          if (this.current?.model !== model) this.chooseModel(model,button.dataset.variant);
        });
        this.modelCards.set(model,button); this.q('[data-models]').append(button); this.updateModelCard(item);
      }
      this.qa('[data-category-filter]').forEach(button => button.addEventListener('click',() => {
        this.category = button.dataset.categoryFilter; this.updateCategories(); this.q('[data-models]').scrollTop = 0;
      }));
      this.qa('[data-upload]').forEach(input => input.addEventListener('change',event => {
        const file = event.currentTarget.files[0];
        event.currentTarget.value = '';
        this.upload(file);
      }));
      this.q('[data-clear]').addEventListener('click',() => this.clearRoom());
      this.qa('[data-sample]').forEach(button => button.addEventListener('click',() => this.sample(button)));
      this.qa('[data-language]').forEach(button => button.addEventListener('click',() => this.setLanguage(button.dataset.language)));
      this.q('[data-compare]').addEventListener('click',() => this.toggleCompare());
      this.qa('[data-slot-tab]').forEach(button => button.addEventListener('click',() => this.setActive(button.dataset.slotTab)));
      for (const key of ['size','angle']) this.q('[data-'+key+']').addEventListener('input',event => {
        this.position[key === 'size' ? 'scale' : 'angle'] = Number(event.target.value)/(key === 'size' ? 100 : 1);
        this.roomOnly = false; this.fanSelected = this.activeSlot; this.invalidateExport(); this.updateUI(); this.draw();
      });
      this.qa('[data-zoom]').forEach(button => button.addEventListener('click',() => {
        if (button.dataset.target) this.setActive(button.dataset.target);
        this.adjustSize(Number(button.dataset.zoom)*4);
      }));
      this.qa('[data-rotate]').forEach(button => button.addEventListener('click',() => this.adjustAngle(Number(button.dataset.rotate)*5)));
      this.q('[data-reset]').addEventListener('click',() => this.reset());
      this.q('[data-before]').addEventListener('click',() => {this.roomOnly = !this.roomOnly; if (this.roomOnly) this.fanSelected = null; this.updateUI(); this.draw();});
      this.q('[data-export]').addEventListener('click',() => this.prepareExport());
      this.q('[data-close-dialog]').addEventListener('click',() => this.q('[data-share-dialog]').close());
      this.q('[data-share-file]').addEventListener('click',() => this.shareFile());
      this.qa('.srp-help input, .srp-help select').forEach(input => input.addEventListener('input',() => this.updateMessage()));
      for (const canvas of this.qa('[data-canvas]')) {
        canvas.width = 1; canvas.height = 1;
        canvas.addEventListener('pointerdown',event => {
          if (event.isPrimary === false || event.button !== 0 || !this.room || !this.slots[canvas.dataset.canvas].fan) return;
          this.setActive(canvas.dataset.canvas);
          const point = this.canvasPoint(event,canvas);
          if (this.roomOnly || !point.inside || !this.hitFan(point,canvas)) {
            this.fanSelected = null; this.updateFanTools(); return;
          }
          event.preventDefault(); this.fanSelected = canvas.dataset.canvas;
          this.drag = {id:event.pointerId,canvas,startX:event.clientX,startY:event.clientY,offsetX:point.x-this.position.x*canvas.width,offsetY:point.y-this.position.y*canvas.height,moved:false};
          canvas.setPointerCapture(event.pointerId); this.updateFanTools();
        });
        canvas.addEventListener('pointermove',event => {
          if (this.drag?.id !== event.pointerId || this.drag.canvas !== canvas) return;
          if (!this.drag.moved && Math.hypot(event.clientX-this.drag.startX,event.clientY-this.drag.startY) < 4) return;
          this.drag.moved = true; this.move(event,canvas);
        });
        for (const name of ['pointerup','pointercancel','lostpointercapture']) canvas.addEventListener(name,event => {
          if (this.drag?.id === event.pointerId) this.drag = null;
        });
        canvas.addEventListener('keydown',event => {
          if (!this.room || !this.slots[canvas.dataset.canvas].fan) return;
          if (['+','=','-','Enter',' ','Escape'].includes(event.key)) {
            event.preventDefault(); this.setActive(canvas.dataset.canvas);
            if (event.key === 'Escape') {this.fanSelected = null; this.updateFanTools();}
            else if (['+','=','-'].includes(event.key)) this.adjustSize(event.key === '-' ? -4 : 4);
            else {this.roomOnly = false; this.fanSelected = canvas.dataset.canvas; this.updateUI(); this.draw(); this.q('[data-fan-tools="'+this.activeSlot+'"] button').focus();}
            return;
          }
          const moves = {ArrowLeft:[-.01,0],ArrowRight:[.01,0],ArrowUp:[0,-.01],ArrowDown:[0,.01]};
          if (!moves[event.key]) return;
          event.preventDefault(); this.setActive(canvas.dataset.canvas);
          const [x,y] = moves[event.key];
          this.position.x = this.clamp(this.position.x+x*(event.shiftKey ? 5 : 1),.05,.95);
          this.position.y = this.clamp(this.position.y+y*(event.shiftKey ? 5 : 1),.05,.95);
          this.roomOnly = false; this.fanSelected = canvas.dataset.canvas; this.invalidateExport(); this.updateUI(); this.draw();
        });
      }
      this.setupCleanup();
      this.resizeObserver = new ResizeObserver(() => this.updateFanTools());
      this.qa('[data-canvas]').forEach(canvas => this.resizeObserver.observe(canvas));
      this.setLanguage('en');
      const params = new URLSearchParams(location.search);
      const requested = params.get('variant') || params.get('fan_variant') || this.dataset.initialVariant;
      const selected = this.items.find(item => item.variant === requested) || this.items.find(item => item.variant === this.dataset.initialVariant) || this.items.find(item => item.available === 'true') || this.items[0];
      if (selected) this.setSlot('a',selected);
      else {this.status('empty_catalog'); this.q('[data-buy]').hidden = true;}
    }
    copyCanvas(source) {
      const canvas = document.createElement('canvas'); canvas.width = source.width; canvas.height = source.height;
      canvas.getContext('2d').drawImage(source,0,0); return canvas;
    }
    setupCleanup() {
      this.cleanToken = 0; this.cleanBusy = false; this.originalRoom = null;
      const dialog = this.q('[data-clean-dialog]'), canvas = this.q('[data-clean-canvas]');
      this.q('[data-remove-old]').addEventListener('click',() => this.openCleanup());
      this.q('[data-restore-room]').addEventListener('click',() => {
        if (!this.originalRoom) return;
        this.room = this.copyCanvas(this.originalRoom); this.roomRepaired = false;
        this.invalidateExport(); this.updateUI(); this.draw(); this.status('clean_restored');
      });
      for (const selector of ['[data-clean-close]','[data-clean-cancel]']) this.q(selector).addEventListener('click',() => dialog.close());
      dialog.addEventListener('close',() => {
        this.cleanToken++; this.cleanBusy = false; this.cleanImage = null; this.cleanUndo = null; this.cleanMask = null; this.cleanDrag = null;
        this.q('[data-clean-canvas]').width = 1; this.q('[data-clean-canvas]').height = 1;
        dialog.removeAttribute('aria-busy'); this.q('[data-remove-old]').focus();
      });
      this.q('[data-clean-size]').addEventListener('input',event => {
        this.q('[data-clean-size-output]').value = event.target.value+'%'; this.drawCleanup();
      });
      this.q('[data-clean-clear]').addEventListener('click',() => {this.clearCleanupMask(); this.cleanStatus('clean_cleared');});
      this.q('[data-clean-apply]').addEventListener('click',() => this.applyCleanup());
      this.q('[data-clean-undo]').addEventListener('click',() => {
        if (!this.cleanUndo || this.cleanBusy) return;
        this.cleanImage = this.cleanUndo; this.cleanUndo = null; this.cleanChanged = this.cleanUndoChanged;
        this.clearCleanupMask(); this.cleanStatus('clean_mark');
      });
      this.q('[data-clean-use]').addEventListener('click',() => {
        if (!this.cleanChanged || this.cleanBusy || this.cleanMarked || !this.room || this.cleanRoomToken !== this.roomToken) return;
        this.room = this.copyCanvas(this.cleanImage); this.roomRepaired = true; this.roomOnly = false;
        this.invalidateExport(); this.updateUI(); this.draw(); this.status('clean_ready'); dialog.close();
      });
      canvas.addEventListener('pointerdown',event => {
        if (this.cleanBusy || !this.cleanMask || event.isPrimary === false || event.button !== 0) return;
        const point = this.canvasPoint(event,canvas); if (!point.inside) return;
        event.preventDefault(); this.cleanCursor = null;
        this.cleanDrag = {id:event.pointerId,point}; canvas.setPointerCapture(event.pointerId); this.markCleanup(point,point);
      });
      canvas.addEventListener('pointermove',event => {
        if (this.cleanBusy || this.cleanDrag?.id !== event.pointerId) return;
        const point = this.canvasPoint(event,canvas);
        if (!point.inside) {this.cleanDrag.point = null; return;}
        this.markCleanup(this.cleanDrag.point || point,point); this.cleanDrag.point = point;
      });
      for (const name of ['pointerup','pointercancel','lostpointercapture']) canvas.addEventListener(name,event => {
        if (this.cleanDrag?.id === event.pointerId) this.cleanDrag = null;
      });
      canvas.addEventListener('keydown',event => {
        if (this.cleanBusy || !this.cleanMask) return;
        const moves = {ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]};
        if (!moves[event.key] && event.key !== ' ') return;
        event.preventDefault(); this.cleanCursor ||= {x:canvas.width/2,y:canvas.height*.22};
        const previous = {...this.cleanCursor};
        if (moves[event.key]) {
          const step = Math.max(1,Math.min(canvas.width,canvas.height)*.01)*(event.shiftKey ? 4 : 1);
          this.cleanCursor.x = this.clamp(this.cleanCursor.x+moves[event.key][0]*step,0,canvas.width);
          this.cleanCursor.y = this.clamp(this.cleanCursor.y+moves[event.key][1]*step,0,canvas.height);
        }
        if (event.key === ' ') this.markCleanup(this.cleanCursor,this.cleanCursor);
        else if (event.shiftKey) this.markCleanup(previous,this.cleanCursor);
        this.drawCleanup();
      });
    }
    openCleanup() {
      if (!this.room) return;
      this.cleanToken++; this.cleanRoomToken = this.roomToken; this.cleanBusy = false; this.cleanChanged = false;
      this.cleanImage = this.copyCanvas(this.room); this.cleanUndo = null; this.cleanCursor = null;
      this.cleanMask = document.createElement('canvas'); this.cleanMask.width = this.room.width; this.cleanMask.height = this.room.height;
      const canvas = this.q('[data-clean-canvas]'); canvas.width = this.room.width; canvas.height = this.room.height;
      this.clearCleanupMask(); this.cleanStatus('clean_mark');
      const dialog = this.q('[data-clean-dialog]'); dialog.showModal(); dialog.scrollTop = 0;
    }
    cleanStatus(key) {this.cleanStatusKey = key; this.q('[data-clean-status]').textContent = this.t(key);}
    clearCleanupMask() {
      if (!this.cleanMask || this.cleanBusy) return;
      this.cleanMask.getContext('2d').clearRect(0,0,this.cleanMask.width,this.cleanMask.height);
      this.cleanMarked = false; this.updateCleanup(); this.drawCleanup();
    }
    brushWidth() {return Math.max(3,Math.min(this.cleanMask.width,this.cleanMask.height)*Number(this.q('[data-clean-size]').value)/100);}
    markCleanup(from,to) {
      const context = this.cleanMask.getContext('2d');
      context.strokeStyle = '#df4764'; context.fillStyle = '#df4764'; context.lineWidth = this.brushWidth(); context.lineCap = 'round'; context.lineJoin = 'round';
      context.beginPath(); context.moveTo(from.x,from.y); context.lineTo(to.x,to.y); context.stroke();
      context.beginPath(); context.arc(to.x,to.y,context.lineWidth/2,0,Math.PI*2); context.fill();
      this.cleanMarked = true; this.updateCleanup(); this.drawCleanup();
    }
    updateCleanup() {
      const busy = Boolean(this.cleanBusy);
      this.q('[data-clean-dialog]').setAttribute('aria-busy',String(busy));
      this.q('[data-clean-apply]').disabled = busy || !this.cleanMarked;
      this.q('[data-clean-apply]').textContent = this.t(busy ? 'clean_busy' : 'remove_marked');
      this.q('[data-clean-undo]').disabled = busy || !this.cleanUndo;
      this.q('[data-clean-clear]').disabled = busy || !this.cleanMarked;
      this.q('[data-clean-size]').disabled = busy;
      this.q('[data-clean-use]').disabled = busy || !this.cleanChanged || this.cleanMarked;
    }
    drawCleanup() {
      if (!this.cleanImage || !this.cleanMask) return;
      const canvas = this.q('[data-clean-canvas]'), context = canvas.getContext('2d');
      context.clearRect(0,0,canvas.width,canvas.height); context.drawImage(this.cleanImage,0,0);
      context.save(); context.globalAlpha = .45; context.drawImage(this.cleanMask,0,0); context.restore();
      if (this.cleanCursor) {
        context.save(); context.beginPath(); context.arc(this.cleanCursor.x,this.cleanCursor.y,this.brushWidth()/2,0,Math.PI*2);
        context.strokeStyle = '#fff'; context.lineWidth = Math.max(2,canvas.width/400); context.stroke();
        context.strokeStyle = '#752c48'; context.lineWidth /= 2; context.stroke(); context.restore();
      }
    }
    async applyCleanup() {
      if (this.cleanBusy || !this.cleanMarked || !this.cleanImage) return;
      this.cleanBusy = true; const token = ++this.cleanToken; this.cleanCursor = null;
      this.updateCleanup(); this.cleanStatus('clean_busy'); this.drawCleanup();
      const source = this.cleanImage, mask = this.cleanMask;
      try {
        await new Promise(resolve => requestAnimationFrame(resolve));
        const repaired = await this.repairCeiling(source,mask,() => token !== this.cleanToken || this.cleanRoomToken !== this.roomToken);
        if (token !== this.cleanToken || this.cleanRoomToken !== this.roomToken) return;
        this.cleanUndo = source; this.cleanUndoChanged = this.cleanChanged; this.cleanImage = repaired; this.cleanChanged = true;
        this.cleanBusy = false; this.clearCleanupMask(); this.cleanStatus('clean_review');
      } catch (error) {
        if (token === this.cleanToken) this.cleanStatus(error.message === 'Selection too large' ? 'clean_large' : 'clean_error');
      } finally {if (token === this.cleanToken) {this.cleanBusy = false; this.updateCleanup();}}
    }
    async repairCeiling(source,mask,cancelled) {
      const factor = Math.min(1,480/Math.max(source.width,source.height));
      const width = Math.max(1,Math.round(source.width*factor)), height = Math.max(1,Math.round(source.height*factor)), count = width*height;
      const small = document.createElement('canvas'); small.width = width; small.height = height;
      const context = small.getContext('2d',{willReadFrequently:true}); context.drawImage(source,0,0,width,height);
      const pixels = context.getImageData(0,0,width,height), original = pixels.data;
      const reducedMask = document.createElement('canvas'); reducedMask.width = width; reducedMask.height = height;
      const maskContext = reducedMask.getContext('2d',{willReadFrequently:true}); maskContext.drawImage(mask,0,0,width,height);
      const rawMask = maskContext.getImageData(0,0,width,height).data, marked = new Uint8Array(count);
      for (let i=0;i<count;i++) if (rawMask[i*4+3]) {
        const x=i%width,y=Math.floor(i/width);
        for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++)if(x+dx>=0&&x+dx<width&&y+dy>=0&&y+dy<height)marked[(y+dy)*width+x+dx]=1;
      }
      const holes=[], boundary=[];
      for(let i=0;i<count;i++) {
        if(marked[i]) holes.push(i);
        else if((i%width>0&&marked[i-1])||(i%width<width-1&&marked[i+1])||(i>=width&&marked[i-width])||(i<count-width&&marked[i+width])) boundary.push(i);
      }
      if(!holes.length||boundary.length<4)throw new Error('Empty selection');
      if(holes.length>count*.28)throw new Error('Selection too large');
      const values = new Float32Array(count*3);
      for(let i=0;i<count;i++)for(let c=0;c<3;c++)values[i*3+c]=original[i*4+c];
      const sum=Array.from({length:3},()=>[0,0,0]); let sx=0,sy=0,sxx=0,sxy=0,syy=0;
      for(const i of boundary){const x=i%width/width,y=Math.floor(i/width)/height;sx+=x;sy+=y;sxx+=x*x;sxy+=x*y;syy+=y*y;for(let c=0;c<3;c++){const v=values[i*3+c];sum[c][0]+=v;sum[c][1]+=v*x;sum[c][2]+=v*y;}}
      const n=boundary.length,a=sxx-sx*sx/n,b=sxy-sx*sy/n,d=syy-sy*sy/n,det=a*d-b*b;
      for(let c=0;c<3;c++){
        const mean=sum[c][0]/n,rx=sum[c][1]-sx*mean,ry=sum[c][2]-sy*mean;
        const ax=Math.abs(det)>1e-8?(rx*d-ry*b)/det:0,ay=Math.abs(det)>1e-8?(ry*a-rx*b)/det:0,base=mean-ax*sx/n-ay*sy/n;
        for(const i of holes)values[i*3+c]=this.clamp(base+ax*(i%width/width)+ay*(Math.floor(i/width)/height),0,255);
      }
      for(let pass=0;pass<180;pass++){
        for(const i of holes){const x=i%width,up=i>=width?i-width:i,down=i<count-width?i+width:i,left=x?i-1:i,right=x<width-1?i+1:i;
          for(let c=0;c<3;c++){const k=i*3+c,average=(values[up*3+c]+values[down*3+c]+values[left*3+c]+values[right*3+c])/4;values[k]=this.clamp(values[k]+1.55*(average-values[k]),0,255);}}
        if(pass%12===0){await new Promise(resolve=>requestAnimationFrame(resolve));if(cancelled())throw new Error('Cancelled');}
      }
      for(const i of holes)for(let c=0;c<3;c++)original[i*4+c]=Math.round(values[i*3+c]);
      context.putImageData(pixels,0,0);
      const result=this.copyCanvas(source), resultContext=result.getContext('2d',{willReadFrequently:true});
      const enlarged=document.createElement('canvas');enlarged.width=source.width;enlarged.height=source.height;
      const enlargedContext=enlarged.getContext('2d',{willReadFrequently:true});enlargedContext.drawImage(small,0,0,source.width,source.height);
      const fill=enlargedContext.getImageData(0,0,source.width,source.height).data,fullMask=mask.getContext('2d').getImageData(0,0,source.width,source.height).data,resultPixels=resultContext.getImageData(0,0,source.width,source.height);
      for(let i=0;i<fullMask.length;i+=4){const alpha=fullMask[i+3]/255;if(!alpha)continue;for(let c=0;c<3;c++)resultPixels.data[i+c]=Math.round(resultPixels.data[i+c]*(1-alpha)+fill[i+c]*alpha);}
      if(cancelled())throw new Error('Cancelled');
      resultContext.putImageData(resultPixels,0,0);return result;
    }
    get current() {return this.slots[this.activeSlot].item;}
    t(key) {return this.copy[this.language]?.[key] || this.copy.en[key] || key;}
    clamp(value,min,max) {return Math.min(max,Math.max(min,value));}
    finish(item) {const key = 'finish_'+item.finish.toLowerCase().replaceAll(' ','_'); return this.copy[this.language]?.[key] || (item.finish === 'Default Title' ? '' : item.finish);}
    status(key) {this.statusKey = key; this.q('[data-status]').textContent = key ? this.t(key) : '';}
    setLanguage(language) {
      this.language = language; this.lang = language; this.dir = language === 'ur' ? 'rtl' : 'ltr';
      this.qa('[data-language]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.language === language)));
      this.qa('[data-i18n]').forEach(el => {el.textContent = this.t(el.dataset.i18n);});
      this.qa('[data-i18n-aria]').forEach(el => el.setAttribute('aria-label',this.t(el.dataset.i18nAria)));
      this.qa('[data-i18n-alt]').forEach(el => {el.alt = this.t(el.dataset.i18nAlt);});
      this.invalidateExport(); this.updateUI(); this.status(this.statusKey || '');
      if (this.cleanImage) {this.cleanStatus(this.cleanStatusKey || 'clean_mark'); this.updateCleanup();}
    }
    updateModelCard(item) {
      const card = this.modelCards.get(item.model);
      card.dataset.variant = item.variant; card.querySelector('.srp-model-price').textContent = item.price;
      const image = card.querySelector('img'); image.src = item.thumb || item.image;
    }
    getFan(url) {
      if (!this.cache.has(url)) {
        if (this.cache.size >= 6) this.cache.delete(this.cache.keys().next().value);
        this.cache.set(url,this.loadFan(url).catch(error => {this.cache.delete(url); throw error;}));
      }
      return this.cache.get(url);
    }
    chooseModel(model,variant) {
      const matching = this.items.filter(item => item.model === model);
      this.setSlot(this.activeSlot,matching.find(item => item.variant === variant) || matching.find(item => item.available === 'true') || matching[0]);
    }
    async setSlot(slot,item) {
      if (!item) return;
      const state = this.slots[slot]; const token = ++state.token;
      if (!this.comparing && state.item?.category !== item.category) this.position = this.defaultPosition(item);
      state.item = item; state.fan = null; state.failed = false; this.fanSelected = null;
      this.invalidateExport(); this.updateModelCard(item); this.updateUI(); this.draw(); this.status('fan_loading');
      try {
        const fan = await this.getFan(item.image);
        if (token !== state.token) return;
        state.fan = fan; this.updateUI(); this.draw();
        this.status(this.ready() ? 'ready' : this.room ? this.visibleSlots().some(key => this.slots[key].failed) ? 'fan_error' : 'fan_loading' : '');
      } catch (error) {if (token === state.token) {state.failed = true; this.updateUI(); this.status('fan_error');}}
    }
    visibleSlots() {return this.comparing ? ['a','b'] : ['a'];}
    defaultPosition(item) {
      if (item?.category === 'pedestal') return {x:.65,y:.72,scale:.18,angle:0};
      if (item?.category === 'wall') return {x:.7,y:.35,scale:.2,angle:0};
      if (item?.category === 'exhaust') return {x:.7,y:.25,scale:.18,angle:0};
      return {x:.5,y:.22,scale:.32,angle:0};
    }
    updateCategories() {
      let count = 0;
      for (const card of this.modelCards.values()) {
        card.hidden = this.category !== 'all' && card.dataset.category !== this.category;
        if (!card.hidden) count++;
      }
      this.qa('[data-category-filter]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.categoryFilter === this.category)));
      this.q('[data-model-count]').textContent = count+' '+this.t('fans_shown');
    }
    optionLabel(name) {
      const value = name.toLowerCase();
      return /colou?r/.test(value) ? this.t('option_colour') : /size|inch/.test(value) ? this.t('option_size') : /voltage|series/.test(value) ? this.t('option_power') : name;
    }
    chooseOption(index,value) {
      const current = this.current;
      const candidates = this.items.filter(item => item.model === current.model && item.options[index] === value);
      const score = item => item.options.reduce((total,option,i) => total+(i !== index && option === current.options[i] ? 2 : 0),item.available === 'true' ? 1 : 0);
      candidates.sort((a,b) => score(b)-score(a));
      if (candidates[0] && candidates[0].variant !== current.variant) this.setSlot(this.activeSlot,candidates[0]);
    }
    ready() {return Boolean(this.room && this.visibleSlots().every(key => this.slots[key].fan));}
    setActive(slot) {
      if (slot === 'b' && !this.comparing) return;
      if (this.activeSlot !== slot) this.fanSelected = null;
      this.activeSlot = slot; this.updateUI();
      if (this.current) this.updateModelCard(this.current);
    }
    toggleCompare() {
      if (!this.room || this.items.length < 2) return;
      this.comparing = !this.comparing; this.fanSelected = null;
      this.activeSlot = this.comparing ? 'b' : 'a';
      this.invalidateExport();
      if (this.comparing && !this.slots.b.item) {
        const alternatives = this.items.filter(item => item.model !== this.slots.a.item?.model);
        const sameType = alternatives.filter(item => item.category === this.slots.a.item?.category);
        const choices = sameType.length ? sameType : alternatives;
        this.setSlot('b',choices.find(item => item.available === 'true') || choices[0] || this.items[0]);
      }
      this.updateUI(); this.draw();
    }
    updateUI() {
      this.dataset.activeSlot = this.activeSlot; this.dataset.comparing = String(this.comparing); this.dataset.hasRoom = String(Boolean(this.room));
      this.q('[data-empty]').hidden = Boolean(this.room); this.q('[data-pictures]').hidden = !this.room;
      this.q('[data-slot="b"]').hidden = !this.comparing;
      this.q('[data-slot-tabs]').hidden = !this.comparing; this.q('[data-compare-note]').hidden = !this.comparing;
      const compare = this.q('[data-compare]'); compare.disabled = !this.room || this.items.length < 2;
      compare.setAttribute('aria-pressed',String(this.comparing)); compare.textContent = this.t(this.comparing ? 'one_fan' : 'compare');
      this.q('[data-remove-old]').disabled = !this.room; this.q('[data-restore-room]').hidden = !this.roomRepaired;
      this.q('[data-clear]').disabled = !this.room; this.q('[data-controls]').disabled = !this.room;
      this.q('[data-export]').disabled = !this.ready() || Boolean(this.exportBusy);
      this.q('[data-export]').textContent = this.t(this.exportBusy ? 'export_busy' : 'save_share');
      this.q('[data-before]').setAttribute('aria-pressed',String(this.roomOnly));
      this.q('[data-before]').textContent = this.t(this.roomOnly ? 'show_fan' : 'hide_fan');
      this.q('[data-size]').value = String(Math.round(this.position.scale*100));
      this.q('[data-size-output]').value = Math.round(this.position.scale*100)+'%';
      this.q('[data-angle]').value = String(this.position.angle); this.q('[data-angle-output]').value = this.position.angle+'°';
      this.q('[data-room-label]').textContent = this.room ? this.t(this.roomKind === 'upload' ? 'your_room' : 'sample_'+this.roomKind) : '';
      this.qa('[data-sample]').forEach(button => button.setAttribute('aria-pressed',String(Boolean(this.room) && button.dataset.sample === this.roomKind)));
      this.q('[data-editing]').textContent = this.t(this.comparing ? this.activeSlot === 'a' ? 'editing_one' : 'editing_two' : 'your_choice');
      for (const key of ['a','b']) {
        const item = this.slots[key].item;
        this.q('[data-slot-tab="'+key+'"]').setAttribute('aria-pressed',String(this.activeSlot === key));
        this.q('[data-slot-label="'+key+'"]').textContent = this.t(key === 'a' ? 'fan_one' : 'fan_two');
        this.q('[data-slot-name="'+key+'"]').textContent = item?.model || '';
        this.q('[data-caption-name="'+key+'"]').textContent = item?.model || '';
        this.q('[data-caption-finish="'+key+'"]').textContent = item ? this.finish(item) : '';
        this.q('[data-caption-price="'+key+'"]').textContent = item?.price || '';
      }
      this.qa('[data-zoom]').forEach(button => {button.disabled = !this.room || !this.slots[this.activeSlot].fan || (Number(button.dataset.zoom) < 0 ? this.position.scale <= .15 : this.position.scale >= .75);});
      this.qa('[data-rotate]').forEach(button => {button.disabled = !this.room || (Number(button.dataset.rotate) < 0 ? this.position.angle <= -30 : this.position.angle >= 30);});
      this.qa('[data-zoom-level]').forEach(output => {output.value = Math.round(this.position.scale*100)+'%';});
      this.updateFanTools();
      const item = this.current;
      for (const [model,card] of this.modelCards) {
        card.setAttribute('aria-pressed',String(model === item?.model));
        card.querySelector('.srp-model-selected').textContent = this.t('selected');
      }
      this.updateCategories();
      if (!item) return;
      const finishes = this.q('[data-finishes]');
      if (finishes.dataset.model !== item.model) {
        finishes.dataset.model = item.model; finishes.replaceChildren();
        const choices = this.items.filter(option => option.model === item.model);
        item.optionNames.forEach((name,index) => {
          if (name === 'Title' && item.options[index] === 'Default Title') return;
          const label = document.createElement('label'), title = document.createElement('span'), select = document.createElement('select');
          label.className = 'srp-option'; title.dataset.optionName = name; select.dataset.optionIndex = index;
          for (const value of new Set(choices.map(choice => choice.options[index]))) {
            const option = document.createElement('option'); option.value = value; option.textContent = value; select.append(option);
          }
          select.addEventListener('change',() => this.chooseOption(index,select.value));
          label.append(title,select); finishes.append(label);
        });
      }
      this.qa('[data-option-name]').forEach(label => {label.textContent = this.optionLabel(label.dataset.optionName);});
      this.qa('[data-option-index]').forEach(select => {select.value = item.options[Number(select.dataset.optionIndex)];});
      this.q('[data-product-name]').textContent = item.model; this.q('[data-price]').textContent = item.price;
      this.q('[data-finish-name]').textContent = this.finish(item); this.q('[data-buy]').href = item.url;
      this.q('[data-availability]').textContent = this.t(item.available === 'true' ? 'stock' : 'sold_out');
      this.q('[data-photo-note]').hidden = item.exactPhoto === 'true';
      this.updateMessage();
    }
    async upload(file) {
      if (!file) return;
      const supportedType = ['image/jpeg','image/png','image/webp'].includes(file.type) || (!file.type && /\.(jpe?g|png|webp)$/i.test(file.name));
      if (!supportedType || file.size > 15*1024*1024) {
        this.status('file_error'); return;
      }
      const token = ++this.roomToken; const url = URL.createObjectURL(file); this.status('room_loading');
      try {
        const image = await this.loadImage(url);
        if (token !== this.roomToken) return;
        if (image.naturalWidth < 200 || image.naturalHeight < 200 || image.naturalWidth*image.naturalHeight > 100000000) throw new Error('Image dimensions');
        this.setRoom(image,'upload');
      } catch (error) {if (token === this.roomToken) this.status('image_error');}
      finally {URL.revokeObjectURL(url);}
    }
    async sample(button) {
      const token = ++this.roomToken; this.status('room_loading');
      try {const image = await this.loadImage(button.dataset.image,true); if (token === this.roomToken) this.setRoom(image,button.dataset.sample);}
      catch (error) {if (token === this.roomToken) this.status('image_error');}
    }
    setRoom(image,kind) {
      const factor = Math.min(1,1600/image.naturalWidth,1600/image.naturalHeight);
      this.room = document.createElement('canvas'); this.room.width = Math.round(image.naturalWidth*factor); this.room.height = Math.round(image.naturalHeight*factor);
      this.room.getContext('2d').drawImage(image,0,0,this.room.width,this.room.height); this.roomKind = kind;
      this.originalRoom = this.copyCanvas(this.room); this.roomRepaired = false; this.cleanToken++;
      if (this.q('[data-clean-dialog]').open) this.q('[data-clean-dialog]').close();
      this.qa('[data-canvas]').forEach(canvas => {canvas.width = this.room.width; canvas.height = this.room.height;});
      this.q('.srp-samples').open = false; this.reset(); this.status(this.ready() ? 'ready' : 'fan_loading');
    }
    clearRoom() {
      this.cleanToken++; this.originalRoom = null; this.roomRepaired = false;
      if (this.q('[data-clean-dialog]').open) this.q('[data-clean-dialog]').close();
      this.roomToken++; this.room = null; this.comparing = false; this.activeSlot = 'a'; this.roomOnly = false; this.fanSelected = null; this.drag = null;
      this.qa('[data-canvas]').forEach(canvas => {canvas.width = 1; canvas.height = 1;});
      this.qa('[data-upload]').forEach(input => {input.value = '';}); this.q('.srp-samples').open = true;
      this.invalidateExport(); this.updateUI(); this.status('cleared');
    }
    reset() {this.position = this.defaultPosition(this.current); this.roomOnly = false; this.fanSelected = null; this.drag = null; this.invalidateExport(); this.updateUI(); this.draw();}
    canvasMetrics(canvas) {
      const box = canvas.getBoundingClientRect();
      const ratio = Math.min(box.width/canvas.width,box.height/canvas.height);
      const width = canvas.width*ratio, height = canvas.height*ratio;
      return {box,ratio,width,height,left:box.left+(box.width-width)/2,top:box.top+(box.height-height)/2};
    }
    canvasPoint(event,canvas) {
      const m = this.canvasMetrics(canvas);
      const x = (event.clientX-m.left)/m.ratio, y = (event.clientY-m.top)/m.ratio;
      return {x,y,inside:x >= 0 && y >= 0 && x <= canvas.width && y <= canvas.height};
    }
    hitFan(point,canvas) {
      const fan = this.slots[canvas.dataset.canvas].fan;
      if (!fan) return false;
      const x = point.x-this.position.x*canvas.width, y = point.y-this.position.y*canvas.height;
      const angle = this.position.angle*Math.PI/180, cosine = Math.cos(angle), sine = Math.sin(angle);
      const localX = x*cosine+y*sine, localY = -x*sine+y*cosine;
      const width = canvas.width*this.position.scale, height = width*fan.height/fan.width;
      const padding = 6/this.canvasMetrics(canvas).ratio;
      return Math.abs(localX) <= width/2+padding && Math.abs(localY) <= height/2+padding;
    }
    move(event,canvas) {
      const point = this.canvasPoint(event,canvas);
      const offsetX = this.drag?.canvas === canvas ? this.drag.offsetX : 0;
      const offsetY = this.drag?.canvas === canvas ? this.drag.offsetY : 0;
      this.position.x = this.clamp((point.x-offsetX)/canvas.width,.05,.95);
      this.position.y = this.clamp((point.y-offsetY)/canvas.height,.05,.95);
      this.roomOnly = false; this.invalidateExport(); this.updateUI(); this.draw();
    }
    adjustSize(amount) {
      if (!this.room || !this.slots[this.activeSlot].fan) return;
      this.position.scale = this.clamp(Math.round(this.position.scale*100+amount),15,75)/100;
      this.roomOnly = false; this.fanSelected = this.activeSlot; this.invalidateExport(); this.updateUI(); this.draw();
    }
    adjustAngle(amount) {
      if (!this.room) return;
      this.position.angle = this.clamp(this.position.angle+amount,-30,30);
      this.roomOnly = false; this.fanSelected = this.activeSlot; this.invalidateExport(); this.updateUI(); this.draw();
    }
    updateFanTools() {
      for (const toolbar of this.qa('[data-fan-tools]')) {
        const slot = toolbar.dataset.fanTools;
        const visible = Boolean(this.room && !this.roomOnly && this.fanSelected === slot && this.activeSlot === slot && this.slots[slot].fan);
        toolbar.hidden = !visible;
        if (!visible) continue;
        const canvas = this.q('[data-canvas="'+slot+'"]'), m = this.canvasMetrics(canvas);
        if (!m.box.width || !m.box.height) {toolbar.hidden = true; continue;}
        const fan = this.slots[slot].fan, angle = this.position.angle*Math.PI/180;
        const fanWidth = m.width*this.position.scale, fanHeight = fanWidth*fan.height/fan.width;
        const extent = Math.abs(Math.sin(angle))*fanWidth+Math.abs(Math.cos(angle))*fanHeight;
        const centreX = (m.box.width-m.width)/2+this.position.x*m.width;
        const bottom = (m.box.height-m.height)/2+this.position.y*m.height+extent/2;
        toolbar.style.left = this.clamp(centreX-toolbar.offsetWidth/2,6,Math.max(6,m.box.width-toolbar.offsetWidth-6))+'px';
        toolbar.style.top = this.clamp(bottom+8,6,Math.max(6,m.box.height-toolbar.offsetHeight-6))+'px';
      }
    }
    paint(context,slot,x,y,width,height,showFan=true) {
      context.save(); context.beginPath(); context.rect(x,y,width,height); context.clip();
      context.drawImage(this.room,x,y,width,height); const fan = this.slots[slot].fan;
      if (fan && showFan) {
        const fanWidth = width*this.position.scale, fanHeight = fanWidth*fan.height/fan.width;
        context.translate(x+width*this.position.x,y+height*this.position.y); context.rotate(this.position.angle*Math.PI/180);
        context.drawImage(fan,-fanWidth/2,-fanHeight/2,fanWidth,fanHeight);
      }
      context.restore();
    }
    draw() {
      if (!this.room) return;
      for (const key of this.visibleSlots()) {
        const canvas = this.q('[data-canvas="'+key+'"]'); const context = canvas.getContext('2d');
        context.clearRect(0,0,canvas.width,canvas.height); this.paint(context,key,0,0,canvas.width,canvas.height,!this.roomOnly);
      }
      this.updateFanTools();
    }
    updateMessage() {
      if (!this.current) return;
      const lines = [this.t(this.comparing ? 'message_compare' : 'message_start')];
      for (const key of this.visibleSlots()) {
        const item = this.slots[key].item; if (!item) continue;
        lines.push(item.model+' — '+item.finish+' — '+item.price,'https://www.sonexfan.com'+item.url);
      }
      for (const key of ['length','width','height','budget','power']) {
        const field = this.q('[data-'+key+']');
        if (field.value && field.checkValidity()) lines.push(this.t(key)+': '+field.value);
      }
      lines.push(this.t('message_end'));
      this.shareText = lines.join('\n');
      const phone = this.dataset.whatsapp.replace(/\D/g,''); const url = 'https://wa.me/'+phone+'?text='+encodeURIComponent(this.shareText);
      for (const selector of ['[data-whatsapp-link]','[data-whatsapp-quick]','[data-whatsapp-export]']) this.q(selector).href = url;
    }
    invalidateExport() {
      this.stateVersion++; this.exportBusy = false; this.exportFile = null;
      if (this.exportUrl) {URL.revokeObjectURL(this.exportUrl); this.exportUrl = null;}
      const dialog = this.q('[data-share-dialog]'); if (dialog.open) dialog.close();
      this.q('[data-export-image]').removeAttribute('src'); this.q('[data-download-link]').removeAttribute('href');
    }
    async prepareExport() {
      if (!this.ready() || this.exportBusy) return;
      this.invalidateExport(); this.exportBusy = true; this.updateUI();
      const version = this.stateVersion;
      try {
        const keys = this.visibleSlots(); const gap = keys.length === 2 ? 16 : 0;
        const panelWidth = keys.length === 2 ? 984 : Math.min(1600,this.room.width);
        const panelHeight = Math.min(1400,Math.round(panelWidth*this.room.height/this.room.width));
        const footer = 122; const output = document.createElement('canvas');
        output.width = panelWidth*keys.length+gap; output.height = panelHeight+footer;
        const context = output.getContext('2d'); context.fillStyle = '#f7f4ed'; context.fillRect(0,0,output.width,output.height);
        keys.forEach((key,index) => {
          const left = index*(panelWidth+gap), item = this.slots[key].item;
          const fit = Math.min(panelWidth/this.room.width,panelHeight/this.room.height);
          const pictureWidth = this.room.width*fit, pictureHeight = this.room.height*fit;
          this.paint(context,key,left+(panelWidth-pictureWidth)/2,(panelHeight-pictureHeight)/2,pictureWidth,pictureHeight,true);
          context.fillStyle = '#302b24'; context.font = 'bold 24px Arial';
          context.fillText('SONEX · '+item.model+' · '+item.finish,left+22,panelHeight+36,panelWidth-44);
          context.font = '18px Arial'; context.fillStyle = '#6b5b46'; context.fillText(item.price,left+22,panelHeight+65,panelWidth-44);
          context.font = '16px Arial'; context.fillText(this.copy.en.watermark,left+22,panelHeight+98,panelWidth-44);
        });
        const blob = await new Promise(resolve => output.toBlob(resolve,'image/jpeg',.92));
        if (version !== this.stateVersion) return;
        if (!blob) throw new Error('Export failed');
        const filename = this.comparing ? 'sonex-fan-comparison.jpg' : 'sonex-'+this.slots.a.item.model.toLowerCase().replace(/[^a-z0-9]+/g,'-')+'-room-preview.jpg';
        this.exportFile = new File([blob],filename,{type:'image/jpeg'}); this.exportUrl = URL.createObjectURL(blob);
        this.q('[data-export-image]').src = this.exportUrl;
        const link = this.q('[data-download-link]'); link.href = this.exportUrl; link.download = filename;
        this.q('[data-export-summary]').textContent = keys.map(key => {const item = this.slots[key].item; return item.model+' · '+this.finish(item)+' · '+item.price;}).join('\n');
        let canShare = false;
        try {canShare = Boolean(navigator.share && navigator.canShare?.({files:[this.exportFile]}));} catch (error) { /* Download remains available. */ }
        this.q('[data-share-file]').hidden = !canShare;
        this.q('[data-share-hint]').textContent = this.t(canShare ? 'share_hint' : 'share_fallback');
        this.q('[data-share-status]').textContent = ''; this.updateMessage(); this.q('[data-share-dialog]').showModal();
      } catch (error) {if (version === this.stateVersion) this.status('export_error');}
      finally {if (version === this.stateVersion) {this.exportBusy = false; this.updateUI();}}
    }
    async shareFile() {
      if (!this.exportFile || !navigator.share) return;
      try {
        await navigator.share({files:[this.exportFile],title:'Sonex room preview',text:this.shareText});
        this.q('[data-share-status]').textContent = this.t('share_opened');
      } catch (error) {this.q('[data-share-status]').textContent = error.name === 'AbortError' ? '' : this.t('share_error');}
    }
      async loadFan(url) {
        const source=await this.loadImage(url,true);
        const canvas=document.createElement('canvas');const factor=Math.min(1,1200/source.naturalWidth,1200/source.naturalHeight);
        canvas.width=Math.round(source.naturalWidth*factor);canvas.height=Math.round(source.naturalHeight*factor);
        const context=canvas.getContext('2d',{willReadFrequently:true});context.drawImage(source,0,0,canvas.width,canvas.height);
        const pixels=context.getImageData(0,0,canvas.width,canvas.height);const data=pixels.data;const w=canvas.width;const h=canvas.height;
        const corners=[0,(w-1)*4,(h-1)*w*4,(w*h-1)*4];
        const background=[0,1,2].map(channel=>corners.map(offset=>data[offset+channel]).sort((a,b)=>a-b)[1]);
        const plainBackground=Math.min(...background)>=225&&Math.max(...background)-Math.min(...background)<=12;
        const seen=new Uint8Array(w*h);const queue=new Int32Array(w*h);let end=0;let start=0;
        const add=index=>{if(seen[index])return;seen[index]=1;const o=index*4;const nearBackground=plainBackground&&background.every((value,channel)=>Math.abs(data[o+channel]-value)<=3);if(data[o+3]===0||nearBackground)queue[end++]=index;};
        for(let x=0;x<w;x++){add(x);add((h-1)*w+x);}for(let y=0;y<h;y++){add(y*w);add(y*w+w-1);}
        while(start<end){const p=queue[start++];data[p*4+3]=0;const x=p%w;const y=Math.floor(p/w);if(x>0)add(p-1);if(x<w-1)add(p+1);if(y>0)add(p-w);if(y<h-1)add(p+w);}
        let left=w,right=0,top=h,bottom=0;
        for(let y=0;y<h;y++)for(let x=0;x<w;x++){if(data[(y*w+x)*4+3]>32){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}}
        if(right<=left||bottom<=top)throw new Error('No product pixels');
        context.putImageData(pixels,0,0);
        const cropped=document.createElement('canvas');cropped.width=right-left+1;cropped.height=bottom-top+1;cropped.getContext('2d').drawImage(canvas,left,top,cropped.width,cropped.height,0,0,cropped.width,cropped.height);
        return cropped;
      }
      loadImage(url,cors=false) {return new Promise((resolve,reject)=>{const image=new Image();if(cors)image.crossOrigin='anonymous';image.onload=()=>resolve(image);image.onerror=reject;image.src=url;});}

  });
}


  } catch(e) { console.error(e); }
})();
})();
